import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/IceRegistration.css"; // Import custom CSS for extra styling

const IceRegistration = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    // Fetch country list from Google's API or an alternative API
    const fetchCountries = async () => {
      try {
        const response = await fetch("https://restcountries.com/v3.1/all"); // Alternative API
        const data = await response.json();
        const countryNames = data.map((country) => country.name.common).sort(); // Extract and sort country names
        setCountries(countryNames);
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    fetchCountries();
  }, []);

  return (
    <>
      {/* Full-width heading */}
      <h2 id="ice-registration" className="text-center bg-dark text-light my-4 py-4 w-100">
        ICE Registration
      </h2>

      {/* Main container for the form */}
      <div className="container py-4">
        <div className="form-container p-4 rounded">
          <form className="row g-3">
            {/* ICE Products & Services */}
            <div className="col-12">
              <label className="form-label">
                Which ICE products and services are you interested in? *
              </label>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="ice1" />
                <label className="form-check-label" htmlFor="ice1">ICEPS</label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="ice2" />
                <label className="form-check-label" htmlFor="ice2">Index Checks</label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="ice3" />
                <label className="form-check-label" htmlFor="ice3">ICEX</label>
              </div>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="ice4" />
                <label className="form-check-label" htmlFor="ice4">Other</label>
              </div>
            </div>

            {/* Other Information */}
            <div className="col-12">
              <label htmlFor="otherInfo" className="form-label">Other Information</label>
              <textarea className="form-control" id="otherInfo" rows="3"></textarea>
            </div>

            {/* Contact Information */}
            <div className="col-md-6">
              <input type="text" className="form-control" id="companyName" placeholder="Company Name" />
            </div>
            <div className="col-md-6">
              <div className="d-flex">
                <input type="text" className="form-control me-2" id="firstName" placeholder="First Name" />
                <input type="text" className="form-control" id="lastName" placeholder="Last Name" />
              </div>
            </div>
            <div className="col-md-6">
              <input type="email" className="form-control" id="email" placeholder="Email"/>
            </div>
            <div className="col-md-6">
              <input type="text" className="form-control" id="phone" placeholder="Phone" />
            </div>
            <div className="col-md-6">
              <label htmlFor="website" className="form-label">Website</label>
              <input type="url" className="form-control" id="website" placeholder="http://" />
            </div>

            {/* Address */}
            <div className="col-12">
              <label htmlFor="address" className="form-label">Address</label>
              <input type="text" className="form-control" id="address" placeholder="Street Address" />
            </div>
            <div className="col-12">
              <input type="text" className="form-control" placeholder="Address Line 2" />
            </div>
            <div className="col-md-4">
              <input type="text" className="form-control" placeholder="City" />
            </div>
            <div className="col-md-4">
              <input type="text" className="form-control" placeholder="State / Province / Region" />
            </div>
            <div className="col-md-2">
              <input type="text" className="form-control" placeholder="ZIP / Postal Code" />
            </div>
            <div className="col-md-2">
              <select className="form-select">
                <option>Country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country}>{country}</option>
                ))}
              </select>
            </div>

            {/* Submit Button */}
            <div className="col-12 text-center">
              <button type="submit" className="btn btn-warning">SUBMIT</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default IceRegistration;
